import { Injectable } from "@angular/core";
import { MatDialogConfig } from "@angular/material/dialog";

export enum DialogType {
    DEFAULT,
    XL,
    LARGE,
    SMALL,
    MEDIUM,
}

@Injectable({
    providedIn: "root",
})
export class DialogConfigService {
    constructor() {}

    getConfig<T>(type: DialogType, data: T, dynamicConfig?: Partial<MatDialogConfig<T>>): MatDialogConfig<T> {
        // Type-specific configurations
        let typeSpecificConfig: Partial<MatDialogConfig<T>>;
        switch (type) {
            case DialogType.XL:
                typeSpecificConfig = { width: "90vw", height: "80vh" };
                break;
            case DialogType.LARGE:
                typeSpecificConfig = { width: "70vw" };
                break;
            case DialogType.SMALL:
                typeSpecificConfig = { width: "20vw" };
                break;
            case DialogType.MEDIUM:
                typeSpecificConfig = { width: "40vw" };
                break;
            default:
                typeSpecificConfig = { width: "40vw" };
        }

        // Merge base config, type-specific config, and dynamic overrides (if any)\
        let config= { ...typeSpecificConfig, ...dynamicConfig };
        config.data = data;
        return config;
    }
}
